import { getLineItemThumbnailUrl, getLineItemPhotoLabel } from '../../../lib/utils';
import PhotoModal, { PhotoModalImage } from './PhotoModal';

const LineItemPhotoModal = ({ isOpen, onClose, lineItem }) => {
  if (!isOpen || !lineItem) return null;

  const imageUrl = getLineItemThumbnailUrl(lineItem);
  const fileName = getLineItemPhotoLabel(lineItem);

  return (
    <PhotoModal
      isOpen={isOpen}
      onClose={onClose}
      ariaLabel="Enlarged photo view"
      fileName={fileName || undefined}
    >
      <PhotoModalImage
        imageUrl={imageUrl}
        alt={fileName || 'Line item photo'}
        isOpen={isOpen}
      />
    </PhotoModal>
  );
};

export default LineItemPhotoModal;
